import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import EditorialButton from '../editorial/EditorialButton';

// Wireframe section 7's persistent bottom bar — visible through the
// whole flow (not just the final Review & Confirm step), so a visitor
// always sees a running total of what they're about to commit to. Before
// a tier is picked it shows the wireframe's own placeholder copy ("No
// tier selected... $0"); once one is, it mirrors getEnrollmentSummary
// exactly so this bar and the Review step never disagree with each other.
export default function StickyTallyBar({ summary, onContinue }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        background: 'var(--navy-900)',
        color: '#fff',
        borderTop: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
        spacing={1.5}
        sx={{ maxWidth: 1040, mx: 'auto', px: { xs: 2, md: 3 }, py: 1.5 }}
      >
        <Box>
          {summary ? (
            <>
              <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: 14 }}>
                {summary.membershipLine}
              </Typography>
              {summary.seatsLine && (
                <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: 13, opacity: 0.75 }}>
                  {summary.seatsLine}
                </Typography>
              )}
            </>
          ) : (
            <>
              <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: 14, fontWeight: 700 }}>
                No tier selected
              </Typography>
              <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: 13, opacity: 0.75 }}>
                Pick a membership above · One-time is the default
              </Typography>
            </>
          )}
        </Box>

        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: 20, fontWeight: 700 }}>
            {summary ? summary.total : '$0'}
          </Typography>
          <EditorialButton variant="primary" onClick={onContinue}>
            Continue
          </EditorialButton>
        </Stack>
      </Stack>
    </Box>
  );
}
